<template>
  <div class="bottom-drawer mx-0 border-top-round d-flex flex-column" @click.stop="false;" dir="rtl" >
    <div class="desktop-only closeX pointer" @click="$emit('close')">X</div>
    <div class="d-flex flex-row padding-20 hidden shadow-bottom" ref="closeBar" style="padding-top:5px; padding-bottom: 10px;">
      <div class="f22-l23-sb mobile-or-tablet" style="padding-top:10px;" @click="$emit('close')">X</div>
      <div class="f22-l23-sb flex-grow-1 text-center" style="padding-top:10px;"> {{dish.title}} </div>
    </div>
    <div class="flex-grow-1 p-0 position-relative" style="overflow-y:auto;" @scroll="showHideCloseBar" id="dishDrawer">
      <SectionImageComponent :image="$responsive(dish.pictures)" />
      <div class="mobile-or-tablet position-absolute cff pointer f22-l23-sb" style="top: 15px; right: 20px" @click="$emit('close')">X</div>
      <LikeComponent v-if="dish.likes" :likes="dish.likes" position="top-right" @click.stop="false" />
      <RatingComponent :rating="dish.rating_preview" class="position-absolute pointer" @click="scrollToRating" style="top: 15px; left: 20px; background-color:rgba(255,255,255,0.7); border-radius: 10px; padding-left:5px; padding-right:5px;" />
      <div class="d-flex flex-column" style="padding-left:20px; padding-right:20px; padding-top:20px;">
        <div class="d-flex flex-row">
          <div class="f22-l23-sb flex-grow-1">
            {{dish.title}}
          </div>
          <div class="d-flex flex-column f18-l21-m text-left" style="min-width:120px;">
            <div class="d-flex flex-row" dir="rtl">
              <div class="flex-grow-1"></div>
              <PriceComponent v-if="dish.price_options.about_price.display.discounted" class="stroke margin-space-after" :value="dish.price_options.about_price.display.nominal_price" />
              <PriceComponent :value="dish.price_options.about_price.display.price || dish.price_options.about_price.display.unit_price" />
            </div>
            <div class="red f18-l21-m">{{dish.price_options.about_price.display.text}}</div>
            <div class="f14-l19">{{dish.price_options.about_price.display.min_amount_text}}</div>
            <div class="f14-l19">{{dish.price_options.about_price.display.content_text}}</div>
          </div>
        </div>

        <div class="text-center margin-top-20 ">
          <span v-if="dish.about.custom_availability_text_html" class="f14-l17">{{ dish.about.custom_availability_text_html }}</span>
        </div>
        <div class="text-center margin-top-10 ">
          <span class="f13-l16-l" v-for="(p,pkey) in dish.tags" :key="pkey">{{p.text}}<span v-if="pkey<Object.keys(dish.tags).length-1" class="red strong"> | </span> </span>
        </div>


        <!-- <div v-if="dish.tags && dish.tags.length>0">
          <DishPreferenceComponent v-for="p in dish.tags" :preference="p" :key="p.search_url" />
        </div> -->
        <HorizontalSplitter v-if="dish.about.description" class="margin-top-10" />
        <div v-if="dish.about.description">
          <div class="margin-top-20">
            <div class="f16-l19-m">{{dish.about.description.label_text}}</div>
            <div class="f14-l17 darkgrey" style="margin-top:10px;" v-html="dish.about.description.description_html"></div>
          </div>
        </div>
        <HorizontalSplitter v-if="dish.about.contents" class="margin-top-20 margin-bottom-20" />
        <div v-if="dish.about.contents">
          <div class="f16-l19-m">{{dish.about.contents.label}}</div>
          <div class="f14-l17 darkgrey" style="margin-top:10px;" v-html="dish.about.contents.contents_html"></div>
        </div>
        <HorizontalSplitter class="margin-top-20 " />
        <!-- simple dish -->
        <div v-if="!dish.about.deal">
          <div class="margin-top-20 f14-l17">
            <div v-for="(portion, idx) in dish.price_options.portions" :key="idx">
              <input class="red-radio" type="radio" style="margin-left: 8px; margin-right: 8px;" name="portion" :checked="portion.portion.id==selectedPortion.id" :id="`portion_`+idx" @change="selectPortion(portion.portion)" />
              <label class="f16-l19-m" :for="`portion_`+idx">{{portion.portion.menu_name}} <span class="f16-l19-m" style="margin-right: 5px;">
                  <PriceComponent :value="portion.portion.unit_price" /></span>
                  <span v-if="portion.portion.discounted" class="f16-l19-m stroke">{{ " " }}<PriceComponent :value="portion.portion.nominal_price" /></span>
                </label>
            </div>
          </div>
          <!-- <HorizontalSplitter class="margin-top-20 margin-bottom-20" /> -->
          <!-- <div>
            <div class="f16-l19-m">{{dish.ingredients.title}}</div>
            <div class="f14-l17 darkgrey" style="margin-top:10px;" v-html="dish.ingredients.dishes.dish.ingredients_html"></div>
          </div> -->
        </div>
        <HorizontalSplitter class="margin-top-20" />
        <div class="accordion accordion-flush p-0" id="accordionfaq">
          <FaqItemComponent v-if="dish.about.variations?.label" :q="dish.about.variations.label" :a="dish.about.variations.text" :a2="dish.about.variations.help_text_html" :idx="2" :show="true" />
          <FaqItemComponent v-if="dish.ingredients" :q="dish.ingredients.title" :a="dish.ingredients.text" :a2="dish.ingredients.dishes.dish.ingredients_html" :idx="3" />
          <FaqItemComponent v-if="dish.heating_notes" :q="dish.heating_notes.title_html" :a="dish.heating_notes.description_html" :idx="0" />
          <FaqItemComponent v-if="dish.storage_notes" :q="dish.storage_notes.title_html" :a="dish.storage_notes.description_html" :idx="1" />
        </div>
        <HorizontalSplitter class="margin-top-20 margin-bottom-20" />
        <div class="padding-20" id="dishRatingSection">
          <CookSectionRating :rating="dish.rating_details" :showOverview="false" />
        </div>
      </div>
    </div>
    <div style="height:90px;padding: 20px" class="d-flex flex-row justify-content-center user-select-none">
      <div class="d-flex flex-row align-items-center addToCartWrapper">
        <div ref="btnPlus" class="amountButton pointer" @click="amountPlus(1)">+</div>
        <div class="red" id="amount" style="margin: 0 10px">{{amount}}</div>
        <div ref="btnMinus" class="amountButton pointer" @click="amountPlus(-1)">-</div>
      </div>
      <div class="d-flex flex-row align-items-center addToCartButton pointer" @click="submitToCart()">
        <div class="white f16-l19-m pointer" style="margin: 0 10px;">{{addToCartText}}</div>
        <div class="white flex-grow-1"></div>
        <div class="white f16-l19-m price-min-width" id="price">
          <PriceComponent :value="price" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {formSubmit} from '@/modules/configuration.js';
import {openCart} from '@/modules/utils.js';
import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
import FaqItemComponent from "@/components/FaqItemComponent.vue";
// import DishPreferenceComponent from "@/components/DishPreferenceComponent.vue";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
import RatingComponent from "@/components/generic/RatingComponent.vue";
import CookSectionRating from "@/components/CookSectionRating.vue";
import LikeComponent from "@/components/generic/LikeComponent.vue";
import PriceComponent from "@/components/generic/PriceComponent.vue";
export default {
  props: {
    dish: {}
  },
  components: {
    SectionImageComponent,
    FaqItemComponent,
    HorizontalSplitter,
    // DishPreferenceComponent,
    RatingComponent,
    CookSectionRating,
    LikeComponent,
    PriceComponent
  },
  data() {
    return {
      loading: true,
      amount: 0,
      selectedPortion: {},
    }
  },
  computed: {
    price() {
      return parseFloat(this.amount * (this.getSelectedPortion()?.unit_price || 0)).toFixed(2);
    },
    addToCartText() {
      return this.getSelectedPortion()?.action_btn?.label;
    }
  },
  methods: {
    async hideMe() {
      this.$router.push(this.dish.cook.url)
    },
    setupDish() {
      let data = this.dish;
      this.selectedPortion = data?.price_options?.portions[0]?.portion || {};
      this.amount = this.selectedPortion.min || 1;
      this.loading = false;
      if (data.title) {
        document.body.classList.add('noscroll');
      }

    },
    enableDisableButtons() {
      const btnPlus = this.$refs.btnPlus;
      const btnMinus = this.$refs.btnMinus;
      const selected = this.getSelectedPortion();
      if (this.amount == selected.min) {
        btnMinus.classList.add('disabled');
      } else {
        btnMinus.classList.remove('disabled');
      }
      if (this.amount == selected.max) {
        btnPlus.classList.add('disabled');
      } else {
        btnPlus.classList.remove('disabled');
      }
    },
    amountPlus(toAdd) {
      let selected = this.getSelectedPortion();
      let amount = this.amount + (toAdd || 0);
      if (amount < (selected.min || 1)) amount = (selected.min || 1);
      if (amount > (selected.max || 10)) amount = (selected.max || 10);
      this.amount = amount;
      this.enableDisableButtons();
    },
    changeAmountToMin() {
      let selected = this.getSelectedPortion();
      this.amount = (selected.min || 1);
      this.enableDisableButtons();
    },
    selectPortion(portion) {
      this.selectedPortion = portion;
      // this.amountPlus(0); //to fix min/max based on portion
      this.changeAmountToMin();
    },
    getSelectedPortion() {
      if (this.selectedPortion.unit_price) return this.selectedPortion;
      if (this.dish?.price_options) return this.dish.price_options.portions[0].portion;
      return null;
    },
    async submitToCart() {
      let response = await formSubmit(this, null, this.getSelectedPortion().action_btn.url + "&amount=" + this.amount);
      openCart(this,response);
      
      // this.$emit('close');
    },
    showHideCloseBar(evt) {
      const closeBar = this.$refs.closeBar;
      if (evt.srcElement.scrollTop > 200) {
        closeBar.classList.remove('hidden');
      } else {
        closeBar.classList.add('hidden');
      }
    },
    async scrollToRating() {
      const scrollToEl = document.getElementById("dishRatingSection");
      const containerElement = document.getElementById("dishDrawer");
      if (scrollToEl) {
        const y = scrollToEl.getBoundingClientRect().top - 100;
        await this.$nextTick();
        containerElement.scrollTo({top: y, behavior: 'smooth'});
      }
    }
  },
  mounted() {
    this.setupDish();
    this.enableDisableButtons();
    this.emitter.on("city-selected", () => {
      this.submitToCart();
    });
  },
  unmounted() {
    this.emitter.off("city-selected");
  },
  // updated() {
  //   this.setupDish();
  //   this.enableDisableButtons();
  // }


}
</script>
<style scoped>
.darkbg {
  display: block;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1999;
}
.bottom-drawer {
  display: block;
  background-color: white;
  position: fixed;
  z-index: 2000;
  bottom: 0;
  left: 0;
  right: 0;
  top: 100px;
  overflow: none;
}

@media (min-width: 1200px) {
  .bottom-drawer {
    width: 510px !important;
    left: 50% !important;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    transform: translateX(-50%);
  }
}

.addToCartWrapper {
  height: 50px;
  background-color: #ffcfd2;
  border-radius: 0 30px 30px 0;
  padding: 10px 15px 10px 10px;
}

.addToCartButton {
  height: 50px;
  background-color: #ef3d49;
  border-radius: 30px 0 0 30px;
  padding: 10px 10px 10px 15px;
}

.amountButton {
  background-color: white;
  border-radius: 15px;
  height: 30px;
  width: 30px;
  text-align: center;
  color: red;
  font-size: 24px;
  line-height: 24px;
}

.amountButton.disabled {
  background-color: #eee;
  color: white;
}

.closeX {
  position: absolute;
  left: -40px;
  color: white;
  font-size: 28px;
  top: -10px;
}
</style>